import React from 'react';
import './Editable.css';
import Select from "react-select";
import {Editable, EditableProps} from "./Editable";
import {useEditable} from "./EditableContext";

type Props<EnclosingType extends object, V> = EditableProps<EnclosingType, V[]> & {
  options: { value: V, label: string }[]
}

export const EditableMultiSelect = <EnclosingType extends object, V>(props: Props<EnclosingType, V>) => {

  const {editing, mode, value, setValue} = useEditable(props);

  const findLabelForValue = (value: V) => {
    for (let i = 0; i < props.options.length; i++) {
      if (props.options[i].value == value) {
        return props.options[i].label;
      }
    }

    // Fall back to the ID. Oops.
    return 'unknown: ' + value;
  }

  if (mode == 'create' || (mode == 'update' && editing && !props.immutable)) {

    return <Editable {...props}>
      <Select
          defaultValue={props.options.filter(v => {
            return value && value.indexOf(v.value) >= 0;
          })}
          isMulti
          options={props.options}
          className="EditableMultiSelect"
          classNamePrefix={'Editable'}
          onChange={value => setValue(value.map(v => v.value))}
      />
    </Editable>
  }

  return <Editable {...props}>
    <div className={'EditableNotEditing'}>
      {value?.map(findLabelForValue).join(', ') || '[None selected]'} 
    </div>
  </Editable>;
}